import {
    Swiper,
    Navigation,
    Autoplay,
} from 'swiper';

Swiper.use([
    Navigation,
    Autoplay,
]);

$(window).on('load', function () {
    let swiper = new Swiper('.occasions__swiper', {
        spaceBetween: 30,
        navigation: {
            nextEl: '.occasions__swiper__controls__next',
            prevEl: '.occasions__swiper__controls__prev',
        },
        autoplay: {
            delay: 7500,
        },
        breakpoints: {
            993: {
                slidesPerView: 3,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
    $(window).on('resize', function () {
        if (swiper.initialized) {
            swiper.update();
        }
    });
});
